<template>
  <modal name="yagish-dialog"
    :adaptive="true"
    :scrollable="true"
    height="auto">
    <div class="v--modal-close-top" v-loading.fullscreen.lock="fullscreenLoading">
      <el-button @click="closeYagishDialog"
        icon="el-icon-circle-close-outline"
        style="font-size: 2rem;"
        type="text"></el-button>
    </div>
    <div class="setting" v-if="permissionType == 1">
      <div class="setting-item" style="text-align:center;">
        <div style="display: inline-block;min-width: 100%;text-align:center;">
          <p style="font-size: 140%;"> 
            <img src="/static/renew_img/logo.svg" style="width:60%" >
          </p>
        </div>
        <p style="font-size: 140%;">職務経歴書専用サイトは閉鎖されました。</p>
        <p style="font-size: 140%;">入力した職務経歴書の内容はバックアップされましたので、履歴書サイトにてログイン後復旧してPDFダウンロードやコンビニプリントをご利用ください。</p>
        <br>
      </div>
      <div class="text-center">
        <el-button id="send-adtop-pdf" type="success" v-if="isSended == false"
        style="background-color:#F60B26;border-color:#F60B26;font-size: 140%;"
          onclick="location.href='https://rirekisho.yagish.jp/mypage'">履歴書サイトのマイページに遷移する</el-button>
        <br/>
      </div>
    </div>
    <div class="setting" v-else-if="permissionType == 2">
      <div class="setting-item" style="text-align:center;">
        <div style="display: inline-block;min-width: 100%;text-align:center;">
          <p style="font-size: 140%;"> 
            <img src="/static/renew_img/logo.svg" style="width:60%" >
          </p>
        </div>
        <p style="font-size: 140%;">ダウンロードが完了しました！！！</p>
        <p style="font-size: 140%;">もしよかったらヤギッシュで<br>一緒に働いてみませんか？</p>
        <p style="font-size: 140%;">設立１年弱で累計利用者数400万人が<br>愛用している国内最大級の履歴書サイトを<br>さらに愛されるものにしていきましょう！</p>
        <br>
        <p style="font-size: 140%;">選考を受けるボタンを押すだけで<br>書類選考を開始できます！</p>
        <p style="font-size: 140%;"><a href="https://blog.yagish.jp/entry/2023/01/04/174328" target="_blank">募集職種などはこちらから。</a></p>
        <p style="font-size: 70%;">
          ※書類選考通過者にのみご連絡をさせていただきます。<br>予めご了承ください。
        </p>
      </div>
      <div class="text-center">
        <el-button id="send-adtop-pdf" type="success" v-if="isSended == false"
        style="background-color:#F60B26;border-color:#F60B26;font-size: 140%;"
          @click="$eventHub.$emit('send-yagish-consult-yagishdialog');">選考を受ける</el-button>
        <el-button id="send-adtop-pdf" type="success" v-if="isSended == true"
        style="background-color:#0F9934;border-color:#0F9934;"
          @click="closeYagishDialog();">送信しました</el-button>
        <br/>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;" v-if="$deviceLib.isApple">
        <p style="font-size: 140%;"> 
          <img src="/static/renew_img/check_icon.png" style="width:40px" >アプリをダウンロードしていつでも編集・PDFをメール送信できるように準備しよう！
        </p>
        <div class="text-center">
          <button type="button" class="el-button el-button--success" id="send-adtop-pdf"  style="background-color:#0F9934;border-color:#0F9934;"
          onClick="window.open('https://apple.co/3GJbCBo', '_blank');" ><span>ヤギッシュアプリを確認！</span></button>
        </div>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;" v-else-if="$deviceLib.isAndroid">
        <p style="font-size: 140%;"> 
          <img src="/static/renew_img/check_icon.png" style="width:40px" >アプリをダウンロードしていつでも編集・PDFをメール送信できるように準備しよう！
        </p>
        <div class="text-center">
          <button type="button" class="el-button el-button--success" id="send-adtop-pdf"  style="background-color:#0F9934;border-color:#0F9934;"
          onClick="window.open('https://bit.ly/3O01VRv', '_blank');" ><span>ヤギッシュアプリを確認！</span></button>
        </div>
      </div>
    </div>
  </modal>
  </template>
  <style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
  <style lang="scss" src="@/assets/scss/pages/setting.scss"></style>
  <script>
  export default {
    components: {
    },
    data: function () {
      return {
        clearLocalStorageConfirmVisible: false,
        currentFormat: {},
        formatid: '',
        previewHtml: '',
        permissionType: 1,
        isSended:false,
        fullscreenLoading:false,
        username:'',
        baite_title:'バイト',
        isAgree:true,
        medleyID:1
      }
    },
    created : function(){
      const app = this
      this.$iterateStorage(function (value, key, iterationNumber) {
          //console.log all the kay/value pairs
          if (key === 'basicData') {
            app.username = value.lastName + '_' + value.firstName
          }
      }, function (err) {
          if (!err) {
              console.log('Iteration has completed');
          }
      })
    },
    computed: {
      cleanedPreviewHtml: function () {
        // PDFで文字化けするやつを変換しておく
        return this.previewHtml
      },
      pdfFormData: function () {
        const formData = new FormData()
        formData.append('app_html', this.cleanedPreviewHtml)
        formData.append('pdf_option', 'A4')
        return formData
      }
    },
    methods: {
      openYagishDialog: function (id, html, permissionType) {
        this.formatid = id
        // this.previewHtml = html.$el.innerHTML
        this.permissionType = permissionType
        this.$modal.show('yagish-dialog')
        this.clearLocalStorageConfirmVisible = false
  
        // const formData = new FormData()
        // formData.append('uuid', this.$firebase.user.uid)
        // formData.append('format_id', this.formatid)
        // formData.append('dialog_name', 'yagish_dialog')
        // formData.append('permission_type', this.permissionType)
        // formData.append('device_flg', 'SP')
        // formData.append('version', '2')
        // formData.append('site_flag', 'k')
        // formData.append('app_flag', 'b')
        // const app = this
        // this.$axios.post(this.$varuna.endPoints.displayDialog, formData, {timeout: 60000})
        // this.$iterateStorage(function (value, key, iterationNumber) {
        //     //console.log all the kay/value pairs
        //     if (key === 'basicData') {
        //       app.username = value.lastName + '_' + value.firstName
        //     }
        // }, function (err) {
        //     if (!err) {
        //         console.log('Iteration has completed');
        //     }
        // })
      },
      closeYagishDialog: function () {
        this.$modal.hide('yagish-dialog')
        this.clearLocalStorageConfirmVisible = false
      },
      confirmWin: function () {
        confirm('応募するデータを送信します。よろしいでしょうか。')
      },
      clearLocalStorage: function () {
        this.$clearStorage()
        window.location = '/'
      },
      createFilename: function (ext) {
        const now = new Date()
        const prefix = process.env.VUE_APP_DOWNLOAD_FILENAME_PREFIX
        const dateString = this.$formLib.dateFormat(now, '_yyyy-mm-dd_HH-MM-ss')
        return `${prefix}${this.formatid}${dateString}.${ext}`
      },
      sendYagishConsult: async function () {
        if (!this.isAgree) {
          this.$message({
            message: 'チェックしてから同意ボタンを押してください。',
            type: 'error'
          })
          return
        }
        // const yagish_url = 'https://blog.yagish.jp/entry/2023/01/04/174355'
        // window.open(yagish_url, '_blank')
        if (!this.$deviceLib.isOnline) {
          this.$message({
            message: '現在オフラインです。インターネットにつながってから再度お試しください',
            type: 'warning'
          })
          return
        }
        await this.$firebase.reloadToken()
        const accessToken = this.$firebase.accessToken
        if (!accessToken || !this.$firebase.user.email) {
          this.$message({
            message: 'ログインが必要です',
            type: 'warning'
          })
          return
        }
        this.fullscreenLoading = true
        const formData = this.pdfFormData
        formData.append('token', accessToken)
        formData.append('apikey', this.$firebase.config.apiKey)
        formData.append('uuid', this.$firebase.user.uid)
        formData.append('format_id', this.formatid)
        formData.append('yaginame', this.username)
        formData.append('app_flag', 'b')
        formData.append('dialog_name', 'yagish_dialog')
        formData.append('permission_type', this.permissionType)
        formData.append('filename', this.createFilename('pdf'))
        formData.append('device_flg', 'SP')
        formData.append('version', '2')
        formData.append('reqflg', '2')
        const app = this
        this.$axios
          .post(this.$varuna.endPoints.yagishPdfMail, formData, {timeout: 60000})
          .then(function (response) {
            app.isSended = true
          })
          .catch(function (error) {
            app.$message({
              message: '送信失敗しました',
              type: 'error'
            })
            app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
          }).finally(function () {
            app.fullscreenLoading = false
          })
      }
    },
    beforeMount: function () {
      this.$eventHub.$on('send-yagish-consult-yagishdialog', this.sendYagishConsult)
      this.$eventHub.$on('open-yagish-dialog', this.openYagishDialog)
      this.$eventHub.$on('popstate', this.closeYagishDialog)
    },
    destroyed: function () {
      this.$eventHub.$off('send-yagish-consult-yagishdialog', this.sendYagishConsult)
      this.$eventHub.$off('open-yagish-dialog', this.openYagishDialog)
      this.$eventHub.$off('popstate', this.closeYagishDialog)
    }
  }
  </script>
  